import { useState } from 'react';
import { SearchOrdersProvider } from '../../contexts/searchOrders';
import { SEARCH } from '../../constants/searchOrders.constant';

const SearchOrdersController = ({
  component: Component,
  ...rest
}) => {
  const [search, setSearch] = useState(SEARCH());

  return (
    <SearchOrdersProvider
      value={{
        search,
        setSearch,
      }}
    >
      <Component {...rest} />
    </SearchOrdersProvider>
  );
};

export const SearchOrdersControllerHOC = (Component) => (props) => (
  <SearchOrdersController component={Component} {...props} />
);

export default SearchOrdersControllerHOC;
